import api from '../../../utils/api'

export const loginApi = (data) => api.post('/admin/autorization/login', data)
export const logoutApi = () => api.put('/admin/autorization/logout')
